// Reducer extracted from AssessmentModule.js

import update from "immutability-helper";
import {
  SET_CURRENT_STEP,
  UPDATE_ASSESSMENT_IN_REDUX,
  UPDATE_FILTERS,
  INIT_FILTERS,
  SAVE_FIELD_UPDATE_ACTIVITY_STATUS,
  CLEAR_FIELD_UPDATE_ACTIVITY_STATUS,
  UPDATE_AI_DATA_IN_REDUX,
  UPDATE_SHOW_AI_QUICK_TIP,
  SET_AI_EVALUATION_EXPANDED_STATE,
  SET_LTI_ATTACHMENT_DELETED,
} from "./AssessmentConstants";

// Initial State
export const initialState = {
  currentStep: "",
  assessmentData: {
    assessmentId: "",
    templateId: "",
    title: "",
    description: "",
    mode: "edit",
    assessmentToolId: "",
    assessmentToolType: "",
    unitSearchText: "",
    maxScore: null,
    initialAssessmentToolTypes: [],
  },
  aiData: {
    shouldGeneratePreviewChat: false,
    aiTutorSelectedTab: null,
    showAITutorSelectedTab: true,
    aiTutorPreviewChatSelectedTabs: {},
    updatedFields: [],
    showAITutorStudentPreviewModal: false,
    isAITutorUpdated: false,
    openModalityId: null,
  },
  filters: {
    searchText: "",
    assessmentTypes: [],
    groupType: "LEARNING_ENGAGEMENT",
  },
  fieldUpdateActivityStatus: {},
  showAIQuickTip: true,
  isAIEvaluationExpanded: false,
  isLtiAttachmentDeleted: false,
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [INIT_FILTERS]: (state, action) => {
    return update(state, {
      filters: { $set: initialState.filters },
    });
  },
  [SET_CURRENT_STEP]: (state, action) => {
    return update(state, { currentStep: { $set: action.data } });
  },
  [UPDATE_SHOW_AI_QUICK_TIP]: (state, action) => {
    return update(state, { showAIQuickTip: { $set: action.data } });
  },
  [UPDATE_ASSESSMENT_IN_REDUX]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        assessmentData: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [UPDATE_AI_DATA_IN_REDUX]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        aiData: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [UPDATE_FILTERS]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        filters: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [SAVE_FIELD_UPDATE_ACTIVITY_STATUS]: (state, action) => {
    return update(state, {
      fieldUpdateActivityStatus: {
        $set: { ...state.fieldUpdateActivityStatus, ...action.data },
      },
    });
  },
  [CLEAR_FIELD_UPDATE_ACTIVITY_STATUS]: (state, action) => {
    return update(state, {
      fieldUpdateActivityStatus: { $set: {} },
    });
  },
  [SET_AI_EVALUATION_EXPANDED_STATE]: (state, action) => {
    return update(state, {
      isAIEvaluationExpanded: { $set: action.data },
    });
  },
  [SET_LTI_ATTACHMENT_DELETED]: (state, action) => {
    return update(state, {
      isLtiAttachmentDeleted: { $set: action.data },
    });
  },
};

// Reducer
export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

// Auto-generated exports
export { REDUCER_HANDLERS };
